module.exports = __webpack_public_path__ + "img/folios-icon-dark.69e1a201.svg";